module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/237-netherlands-10e352e17bc4e2b878b6698c1ee0540a.svg";